import React from 'react';
import PropTypes from 'prop-types';

import BlockWrapper from './shared/BlockWrapper';
import fabric from '../../../common/fabric';

const Chart = props => {
  const bbContainer = React.useRef(null);
  const { hyperlink, style, matrixGroup, globalScale } = props;

  const [params, setParams] = React.useState(props.params);

  React.useEffect(() => {}, [props.params]);

  const groupMatrix = matrixGroup
    ? fabric.util.multiplyTransformMatrices(
        matrixGroup,
        params.ludus.transformMatrix,
      )
    : params.ludus.transformMatrix;

  const transformMatrix = fabric.util.multiplyTransformMatrices(
    [globalScale, 0, 0, globalScale, 0, 0],
    groupMatrix,
  );

  React.useEffect(() => {
    function removeAllChildNodes(parent) {
      while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
      }
    }

    const chartDataTxt = props.params.chartDataTxt;
    const chartTypeSelect = props.params.chartType;
    const {
      chartType,
      valueData,
      chartColors,
    } = fabric.LudusChart.transformData(chartDataTxt, chartTypeSelect.value);
    bbContainer.current && removeAllChildNodes(bbContainer.current);
    fabric.LudusChart.generateChart(
      valueData,
      chartType,
      {
        width: props.params.width,
        height: props.params.height,
      },
      chartColors,
      bbContainer.current,
      props.params.ludus.chartConfig,
    );
    setParams(props.params);
  }, [props.params]);

  return (
    <BlockWrapper
      globalCompositeOperation={params.globalCompositeOperation}
      groupAngle={props.groupAngle}
      localScale={props.params.scaleX / props.groupScaleX}
      shadow={params.shadow || null}
      hyperlink={hyperlink}
      style={{
        ...style,
        left: 0,
        top: 0,
        opacity: props.params.opacity,
        transformOrigin: 'center center',
        transform: `translate(-50%, -50%) matrix(${transformMatrix})`,
      }}
    >
      <div ref={bbContainer} />
    </BlockWrapper>
  );
};

Chart.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  // globalScale: PropTypes.number.isRequired,
  groupAngle: PropTypes.number.isRequired,
  // groupOpacity: PropTypes.number.isRequired,
  groupScaleX: PropTypes.number.isRequired,
  hyperlink: PropTypes.string,
  matrixGroup: PropTypes.arrayOf(PropTypes.number),
  globalScale: PropTypes.number,
};
Chart.defaultProps = {
  hyperlink: null,
  matrixGroup: null,
  globalScale: 1,
};

export default Chart;
